import { createUseStyles } from 'react-jss'

import { lightGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  reportFiltersContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${lightGrey}`,
    borderRadius: 8,
    padding: '4px 6px',
    marginTop: 34
  },
  reportFiltersLabel: {
    fontStyle: 'italic',
    display: 'flex',
    fontWeight: '700',
    gap: 5,
    alignItems: 'center'
  },
  filters: {
    display: 'flex',
    gap: 20
  },
  select: {
    minWidth: 200
  }
})

export default useStyles
